(function(){
    'use strict';

    const productConfigSelect = document.querySelector('.js-action--productConfigSelect');
    const params = new URLSearchParams(window.location.search);
    const isSharedConfig = params.get('sharedProductConfig');

    if (!productConfigSelect && !isSharedConfig) {
        return;
    }

    productConfigSelect.addEventListener('change', function() { window.location.assign(this.value); }, false);
    document.addEventListener('DOMContentLoaded', () => {
        productConfigSelect.childNodes.forEach(node => {
            if (node.nodeName === 'OPTION' && node.value != '' && node.value === window.location.href) {
                setSelectedIndex(node.index);
                return;
            }
        });
    });

    function setSelectedIndex (currenmtIndex) {
        productConfigSelect.selectedIndex = currenmtIndex;
    }

}());